import { render, staticRenderFns } from "./CardResearchIcon.vue?vue&type=template&id=77689cfb&scoped=true&"
import script from "./CardResearchIcon.vue?vue&type=script&lang=js&"
export * from "./CardResearchIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardResearchIcon.vue?vue&type=style&index=0&id=77689cfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77689cfb",
  null
  
)

export default component.exports